/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_TInputs */

const en_tut_meja_t = /** @type {(inputs: Tut_Meja_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Private desks and desk conversations`)
};

const id_tut_meja_t = /** @type {(inputs: Tut_Meja_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meja privat dan percakapan meja`)
};

/**
* | output |
* | --- |
* | "Private desks and desk conversations" |
*
* @param {Tut_Meja_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_t = /** @type {((inputs?: Tut_Meja_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_t(inputs)
	return en_tut_meja_t(inputs)
});